import { ButtonHTMLAttributes, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinningIcon = styled.i`
  animation: ${spin} 1s linear infinite;
`;

export const SubmitButton = ({
  loading,
  children,
  dark,
  className,
  ...props
}: {
  loading?: boolean;
  children: JSX.Element | string;
  dark?: boolean;
  className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>) => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    let timeout: number;

    if (loading) {
      timeout = setTimeout(() => setShowLoading(true), 10);
    } else {
      setShowLoading(false);
    }
    return () => clearTimeout(timeout);
  }, [loading]);

  return (
    <button
      {...props}
      disabled={loading}
      className={className}
      style={{ display: "inline-flex", alignItems: "center", flexDirection: "column" }}
    >
      <div style={showLoading ? { height: 0, opacity: 0 } : {}}>{children}</div>
      {showLoading && <SpinningIcon className="bi bi-opencollective" />}
    </button>
  );
};
